module.exports = __webpack_public_path__ + "static/media/location.bdae4078.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Common/StatsBox/img/location.svg
// module id = 174
// module chunks = 0